import type { TenantSubscription } from '@lensora/shared'
import { useFeatureFlag } from '@lensora/ui'
import { useQuery } from '@tanstack/react-query'


import { isSelfServeClient, useMe } from '@/hooks/use-me'
import { api } from '@/lib/api'


export function useSubscription() {
  const billingEnabled = useFeatureFlag('billing_enabled')
  const { data: me } = useMe()

  // Self-serve customers' subscription state is authoritative from the API —
  // `billing_enabled` is a tenant-admin flag that billing's client-scope
  // webhooks are forbidden from writing, so it must not gate self-serve
  // billing UI (see docs/architecture.md, docs/agents/billing.md). A
  // 404/no-subscription API response is what signals "no subscription" for
  // that path, not this flag. Tenant-scope (agency) behavior is unchanged.
  const enabled = isSelfServeClient(me) || billingEnabled

  return useQuery({
    queryKey: ['subscription'],
    queryFn: () => api.get<TenantSubscription>('/api/billing/subscription'),
    enabled,
    retry: false,
  })
}
